import React from 'react'
import { useAuthContext } from '../../../Context'
import { NameCon } from './styles'

export const ProfileName: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { firstName, lastName } = useAuthContext()

  return (
    <>
      {firstName && lastName && (
        <NameCon>
          <p className="name">
            {firstName} {lastName}
          </p>
        </NameCon>
      )}
    </>
  )
}
